window.helpers = {
	triggerEl : null,
	isEscape : function(e) {
		// keyCode is getting deprecated use key instead when supported, which makes this messy
		var evt = e || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = (evt.key == "Escape" || evt.key == "Esc");
		} else {
			isEscape = (evt.keyCode == 27);
		}
		return isEscape;
	},
	trapFocus : function(elementId, focusFirst = true) {
		const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
		const trap = document.querySelector(elementId); // select the trap by it's id
		const firstFocusableElement = trap.querySelectorAll(focusableElements)[0]; // get first element to be focused inside trap
		const focusableContent = trap.querySelectorAll(focusableElements);
		const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap

		document.addEventListener('keydown', function (e) {
			let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

			if (!isTabPressed) {
				return;
			}

			if (e.shiftKey) { // if shift key pressed for shift + tab combination
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus(); // add focus for the last focusable element
					e.preventDefault();
				}
			} else { // if tab key is pressed
				if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
					firstFocusableElement.focus(); // add focus for the first focusable element
					e.preventDefault();
				}
			}
		});
		if (focusFirst) {
			setTimeout(() => {
				firstFocusableElement.focus();
			}, 350);
		}
	},
	returnFocus : function() {
		if( window.helpers.triggerEl ) {
			jQuery(window.helpers.triggerEl).focus();
			window.helpers.triggerEl = null;
		}
	}
};